import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { EvaDialogComponent } from "../eva-dialog/eva-dialog.component";
import { EvaConfirmService } from "./eva-confirm.service";

/** Hôte unique (app.component) des confirmations d'EvaConfirmService : un second les doublerait. */
@Component({
  selector: "eva-confirm-dialog",
  standalone: true,
  imports: [EvaDialogComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (request of requests(); track request) {
      <!-- eva-dialog part dans <body> : la div reste en place comme ancre de la vue suivante. -->
      <div>
        <eva-dialog
          [visible]="true"
          type="confirm"
          size="sm"
          [header]="request.header ?? 'Confirmation'"
          [confirmLabel]="request.acceptLabel ?? 'Oui'"
          [cancelLabel]="request.rejectLabel ?? 'Non'"
          [confirmSeverity]="request.severity ?? 'primary'"
          (onConfirm)="confirmService.accept()"
          (onCancel)="confirmService.reject()"
        >
          <p class="eva-confirm-dialog__message">{{ request.message }}</p>
        </eva-dialog>
      </div>
    }
  `,
  styles: [
    `
      .eva-confirm-dialog__message {
        margin: 0;
        white-space: pre-line;
      }
    `,
  ],
})
export class EvaConfirmDialogComponent {
  protected readonly confirmService = inject(EvaConfirmService);

  // Une vue par demande : réutilisée, une confirmation enchaînée depuis reject() resterait masquée.
  protected readonly requests = computed(() => {
    const request = this.confirmService.request();
    return request ? [request] : [];
  });
}
